import {
  SchemaValidationErrorLabel,
  shortDisplayTextForSchemaValidationErrorLabel,
} from 'schemas/SchemaValidationConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getSchemaValidationErrorLabelMenuOptionDatas(): Promise<Array<OptionData>> {
  return Promise.resolve(
    [
      SchemaValidationErrorLabel.CONSTRAINT_VIOLATION,
      SchemaValidationErrorLabel.INVALID_LINK,
      SchemaValidationErrorLabel.INVALID_MULTIPLE_LINK,
      SchemaValidationErrorLabel.INVALID_VALUE,
      SchemaValidationErrorLabel.MISSING_REQUIRED,
      SchemaValidationErrorLabel.OTHER,
    ].map((errorLabel) => ({
      value: errorLabel,
      name: shortDisplayTextForSchemaValidationErrorLabel(errorLabel),
    }))
  );
}
